import React from 'react';
import { useLocation } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary.tsx';

/**
 * Error boundary for the routed screen area, keyed on the current path.
 *
 * Sits INSIDE the navigation chrome so that when one screen throws, the nav bar
 * stays usable and the user can click their way out — rather than being stuck
 * with a full-page fallback and only the browser back button. Keying on
 * `pathname` means navigating to any other screen clears the error
 * automatically, so a user is never stuck on a stale fallback.
 */
const RouteErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  return (
    <ErrorBoundary
      resetKeys={[location.pathname]}
      title="This screen didn’t load"
      description="Something went wrong rendering this page. Your data is safe — nothing was saved or changed. You can retry, or use the menu above to go somewhere else."
    >
      {children}
    </ErrorBoundary>
  );
};

export default RouteErrorBoundary;
